import type { IconData } from '@stacksjs/iconify-core'

export const musicNote2: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#8fbffa\" d=\"M14 12.923c0-1.88 1.049-3.62 2.772-4.372c9.086-3.96 18.557-5.094 23.24-5.42C41.663 3.018 43 4.345 43 6.002v26h-.014A8.5 8.5 0 1 1 37 23.375v-8.801c-4.183.507-10.216 1.612-17 4.018v18.41h-.015A8.5 8.5 0 1 1 14 28.374z\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M14 12.922c0-1.88 1.049-3.62 2.772-4.372c9.086-3.96 18.557-5.094 23.24-5.42C41.663 3.017 43 4.344 43 6.001v26h-.014A8.5 8.5 0 1 1 37 23.374v-8.801c-4.183.507-10.216 1.613-17 4.018v18.41h-.015A8.5 8.5 0 1 1 14 28.373z\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default musicNote2
